import React from "react";

import Buttons from "./Buttons";

const Header = ({ className, title, links, history, primaryButtons, buttons }) => {
  return (
    <div className={`flex-col margin-header ${className}`}>
      {title && <h3 className="title">{title}</h3>}
      {(primaryButtons || buttons) &&
        <Buttons
          history={history}
          primary={primaryButtons}
          buttons={buttons}
        />}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/ContainerHeader.js